import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { birthdayShoppingTtkSchema } from "../schemas";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const BirthadayShoppingTTK = () => {
  const { language, currency } = useUserAuth();
  const [ttkEditMode, setTtkEditMode] = useState(false);
  const { user, token } = useUserAuth();
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState({});
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = res.data.data;
      const details = data[0].details;
      // const details = rawDetails ? JSON.parse(rawDetails) : null;
      if (details) {
        setMerchant(details);
        // formik.setValues(details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  const workingSinceOption = checkboxData.workSinceOption;
  const birthdayDecorationOption = checkboxData.birthadayDecorationItems;
  const areaOfWorkingOption = checkboxData.areaOfWorking;

  const formik = useFormik({
    initialValues: {
      price: Math.floor(merchant?.price * currency.value) || "",
      workingSince: merchant?.workingSince || [],
      birthadayDecoration: merchant?.birthadayDecoration || [],
      areaOfWorking: merchant?.areaOfWorking || [],
    },
    enableReinitialize: true,
    validationSchema: birthdayShoppingTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: {
            ...values,
            price: Math.floor(values.price * currency.country_value),
          },
        };

        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 201) {
          toast.success("Things to know added successfully.");
          setMerchant(values);
          formik.setValues(values);
          setTtkEditMode(false);
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
          setTtkEditMode(false);
        } else {
          toast.info(res.data.message || "Request submitted.");
          setTtkEditMode(false);
        }
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while submitting the data.");
      }
    },
  });
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
         <ThinksToKnowStatus/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header  text-white text-center "
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5>
                  {" "}
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff " }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Working Since</th>
                            <th style={{ width: "25%" }}>
                              Birthaday Decoration Items
                            </th>
                            <th style={{ width: "25%" }}>Serving Cities</th>
                            <th style={{ width: "25%" }}>Price</th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.workingSince?.map((item, index) => {
                                return <span key={index}>{item.value}</span>;
                              })}
                            </td>
                            <td>
                              {merchant.birthadayDecoration?.map(
                                (item, index) => {
                                  return (
                                    <>
                                      <i className="fa fa-check text-success" />
                                      <span key={index}>{item.value} </span>
                                    </>
                                  );
                                }
                              )}
                            </td>

                            <td>
                              {merchant.areaOfWorking?.map((item, index) => {
                                return (
                                  <>
                                    <i className="fa fa-check text-success" />
                                    <span key={index}>{item.value} </span>
                                  </>
                                );
                              })}
                            </td>

                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.price
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn text-white mb-2"
                    style={{ backgroundColor: "#085f9a" }}
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${
                    merchant ? "Make Changes" : "Tell me more about yourself"
                  }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Working Since <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workingSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                          formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Birthaday Decoration Items
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={birthdayDecorationOption}
                            selected
                            value={formik.values.birthadayDecoration}
                            onChange={(birthadayDecoration) =>
                              formik.setFieldValue(
                                "birthadayDecoration",
                                birthadayDecoration
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.birthadayDecoration &&
                          formik.errors.birthadayDecoration ? (
                            <div className="text-danger">
                              {formik.errors.birthadayDecoration}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Serving Cities</label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={areaOfWorkingOption}
                            selected
                            value={formik.values.areaOfWorking}
                            onChange={(areaOfWorking) =>
                              formik.setFieldValue(
                                "areaOfWorking",
                                areaOfWorking
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.areaOfWorking &&
                          formik.errors.areaOfWorking ? (
                            <div className="text-danger">
                              {formik.errors.areaOfWorking}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Starting Price</label>
                          <input
                            type="number"
                            placeholder="Starting Price"
                            className="form-control"
                            name="price"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.price}
                          />
                          {formik.touched.price && formik.errors.price ? (
                            <div className="text-danger">
                              {formik.errors.price}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn text-white"
                        type="submit"
                        style={{ backgroundColor: "#085f9a" }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BirthadayShoppingTTK;
